import { createApp } from 'vue'
// import { ref } from 'vue'

import App from './App.vue'
import './scss/hktdc.scss'

import mitt from 'mitt';
const emitter = mitt();


const app = createApp(App);
app.config.globalProperties.emitter = emitter;

import VueGtag from "vue-gtag-next";

app.use(VueGtag, {
    property: {
        id: 'G-08B5QDRNJQ'
    }
  });

app.mount('#app');
